import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root'
})
export class SupportService {
    base64url(source: any) {
        let encodedSource = CryptoJS.enc.Base64.stringify(source);

        encodedSource = encodedSource.replace(/=+$/, '');

        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');

        return encodedSource;
    }

    encodeToken(payload: any) {
        const header = {
            alg: 'HS256',
            typ: 'JWT'
        };

        const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
        const encodedHeader = this.base64url(stringifiedHeader);

        const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
        const encodedData = this.base64url(stringifiedData);

        return encodedHeader + '.' + encodedData;
    }

    signToken(payload: any, key: string) {
        const secret = key;
        payload.iss = 'https://accounts.breed.gr';
        payload.exp = DateTime.now().plus({ minutes: 5 }).toSeconds();
        const token: any = this.encodeToken(payload);

        let signature: any = CryptoJS.HmacSHA256(token, secret);
        signature = this.base64url(signature);

        const signedToken = token + '.' + signature;
        return signedToken;
    }

    decodeToken(token: string) {
        const _decodeToken = (token: string) => {
            try {
                return JSON.parse(atob(token));
            } catch {
                return;
            }
        };

        return token
            .split('.')
            .map((token) => _decodeToken(token))
            .reduce((acc, curr) => {
                if (curr) acc = { ...acc, ...curr };
                return acc;
            }, Object.create(null));
    }
}
